// it-IT
export default {
	title: "Centro Carte Regalo",
	myPoints: "I Miei Punti",
	SelectedGifts: "Regali Selezionati",
	form: {
		label: {
			title: "Ricerca",
			points: "Punti"
		}
	},
	redemption: "Redenzione",
	stock: "Azione",
	id: {
		redeemPoints: "Riscatta i punti necessari:",
		btn: "Riscatta Ora",
		title: "Avviso di Acquisto",
		content: `Caro lavoratore, grazie per la tua partecipazione al lavoro.\n\nLeggi i seguenti termini prima di riscattare i punti:\n\n[Punti di lavoro] Dopo il completamento giornaliero dell'ottimizzazione dei dati del set di ordini, i lavoratori possono guadagnare 1 punto regalo, che può essere utilizzato per il riscatto parziale della sponsorizzazione del regalo.\n[Riscatto del regalo] I lavoratori devono fornire le informazioni pertinenti sull'indirizzo di spedizione e il regalo verrà spedito gratuitamente in tutto il mondo entro 14 giorni. Una volta completato il riscatto, puoi contattare il servizio clienti per ottenere il numero di tracciamento per monitorare lo stato di avanzamento del regalo. La piattaforma non divulgherà informazioni a terzi.\nNota: una volta riscattati i punti per regali, non possono essere rimborsati`
	},
	applyDialog: {
		title: "Ricezione Informazioni",
		form: {
			consignee: "Destinatario",
			area: "Area",
			telephone: "Telefono",
			deliveryAddress: "Indirizzo di consegna"
		},
		btn: "Invia a"
	},
	records: {
		title: "Registri",
		status: ["In attesa di spedizione", "Spedito", "Consegnato", "Annullato"]
	}
};
